/*
 * File: EmailAccountInput.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 14, 2025 at 11:18 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	position: relative;
`;

export const Locker = styled.div`
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	z-index: 3;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0px 0.75rem;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.inputBorder};
	background-color: ${({ theme }) => theme.tertiaryBackground};

	p {
		flex-grow: 1;
		flex-shrink: 1;
		font-size: 1rem !important;
		margin: 0px 0px 0px 1px;
		min-width: 0;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	button {
		margin: 0px !important;
		width: 70px !important;
		padding: 0px;
		z-index: 4;
		height: 100%;
		flex-shrink: 0;
		flex-grow: 0;
	}
`;
